<h2 mat-dialog-title class="d-flex align-items-center justify-content-between">
  <span>{{ dialogData.title ?? dialogData.data.type }}</span>
  <button matIconButton mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="data-detail-dialog__content">
  <app-content-data-viewer [data]="dialogData.data" [expanded]="2" />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
